import type { ShowcaseItem } from '@/hooks/useShowcase';

// Source 1 of 2 for the gallery (see also the backend `/showcase` endpoint):
// hand-picked landing examples that ALWAYS show, independent of the curated
// prod feed. These are self-hosted (Vercel blob / public /videos), so they
// never expire and don't depend on the API or S3 presigning.
//
// The gallery page (src/pages/Showcase/index.tsx) fetches the curated prod
// reels from /showcase and merges these in after them, deduped by id.
export const SHOWCASE_EXAMPLES: ShowcaseItem[] = [
  {
    id: 'example-coffee',
    title: 'Coffee Shop Story',
    topic: 'A humorous video about coffee addiction and morning routines',
    platform: null,
    prompt: 'A funny take on morning coffee addiction',
    model: 'Kling',
    video_url:
      'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/videos/coffee-landing.mp4',
    thumbnail_url: null,
  },
  {
    id: 'example-rick',
    title: 'Avant-Garde Fashion',
    topic: 'A brutalist fashion showcase with architectural influences',
    platform: null,
    prompt:
      "A brutalist concrete runway emerges from darkness, illuminated by harsh, directional lighting. Models move with deliberate, almost ritualistic movements, wearing avant-garde silhouettes in monochromatic blacks and greys. Their forms cast dramatic shadows against bare concrete walls. The camera glides smoothly, capturing both the architectural severity of the space and the fluid movement of the garments. Smoke drifts across the floor, creating an ethereal atmosphere that contrasts with the structural hardness. The collection embodies a post-apocalyptic elegance: draped fabrics, geometric cutouts, and architectural shapes that echo Rick Owens' design philosophy. The finale shows all models in formation, their silhouettes creating a living sculpture against the brutalist backdrop.",
    model: 'Veo2',
    video_url:
      'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/videos/landing_rick.mp4',
    thumbnail_url: null,
  },
  {
    id: 'example-ando-2',
    title: 'Architectural Poetry',
    topic: "A visual exploration of Tadao Ando's iconic spaces",
    platform: null,
    prompt:
      "A meditative journey through Tadao Ando's architectural masterpieces in Japan. The camera floats through the Church of Light in Osaka, where sunbeams pierce through the cruciform void, creating a dramatic play of light and shadow on raw concrete. Transitions flow seamlessly to Benesse House in Naoshima, following water elements that reflect sky and concrete. The focus is on the interplay between natural and man-made elements: circular openings frame the sky, geometric shadows move across textured concrete walls, and water features mirror the architecture in perfect symmetry. The movement is slow and contemplative, emphasizing the spiritual quality of the spaces. Natural sounds of water and wind complement the visual journey.",
    model: 'Kling',
    video_url:
      'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/videos/landing_ando_2.mp4',
    thumbnail_url: null,
  },
  {
    id: 'example-ando',
    title: "Tadao Ando's Designs",
    topic: "Journey through Ando's masterpieces in Japan",
    platform: null,
    prompt: 'Tadao Ando Designs in Osaka and Naoshima',
    model: 'Kling',
    video_url:
      'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/videos/landing_ando.mp4',
    thumbnail_url: null,
  },
  {
    id: 'example-whimsical',
    title: 'Whimsical',
    topic: 'Wes Anderson-style symmetrical, pastel montage',
    platform: null,
    prompt:
      'Wes Anderson-style video — perfectly symmetrical framing, a pastel palette, and a whimsical deadpan montage of tiny tableaux.',
    model: 'Kling',
    video_url: '/videos/preset-whimsical.mp4',
    thumbnail_url: null,
  },
  {
    id: 'example-vision',
    title: 'SmartReels Creative Vision',
    topic: 'An introspective journey through the creative process',
    platform: null,
    prompt:
      "Create a cinematic, introspective video of a creator standing in a minimalist room, speaking in an inner monologue. They're separated from the world by a glass wall. As they speak, we see subtle reflections of people on the other side—potential users, perhaps unaware of his presence. The creator questions whether his message is clear. Abstract visuals begin to appear: floating ideas, fragments of content, hints of creativity forming. The tone shifts from uncertainty to clarity. A glowing interface appears in front of him, representing his tool—SmartReel. He reaches toward it calmly. The figures on the other side pause, as if something just clicked. End with a fade to black and the SmartReel logo. Voiceover should be poetic and personal, ending with the line: 'Maybe they're not listening yet… but they'll feel it when they press play.'",
    model: 'Kling',
    video_url:
      'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/videos/landing.mp4',
    thumbnail_url: null,
  },
];
